import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import * as React from 'react';
import pickBy from 'lodash/pickBy';
import { Formik } from 'formik';
import { FormErrorScroller } from './FormErrorScroller/FormErrorScroller';
import { FormWrapper } from './FormWrapper';

function handleSubmit(onSubmit) {
  return function innerSubmit(values, actions) {
    actions.setStatus({
      hasError: false
    });
    Promise.resolve(onSubmit(values, actions)).then(function () {
      actions.setFormikState({
        isSubmitting: false
      });
    }).catch(function () {
      actions.setStatus({
        hasError: true
      });
      actions.setFormikState({
        isSubmitting: false
      });
    });
  };
}

function squashValidate(validate) {
  if (!validate) {
    return undefined;
  }

  return /*#__PURE__*/function () {
    var _innerValidate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.resolve(validate(values));

            case 2:
              result = _context.sent;

              if (!(result && typeof result === 'object')) {
                _context.next = 5;
                break;
              }

              throw pickBy(result);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function innerValidate(_x) {
      return _innerValidate.apply(this, arguments);
    }

    return innerValidate;
  }();
}

export function FormOnChangeTracker(_ref) {
  var form = _ref.form,
      onChange = _ref.onChange;
  var values = React.useRef(form.values);
  React.useEffect(function () {
    if (values.current !== form.values) {
      var prevValues = values.current;
      values.current = form.values;
      onChange(form.values, prevValues, form);
    }
  }, [form, onChange]);
  return null;
}
export function Form(_ref2) {
  var children = _ref2.children,
      onSubmit = _ref2.onSubmit,
      _ref2$scrollsToErrorA = _ref2.scrollsToErrorAfterSubmit,
      scrollsToErrorAfterSubmit = _ref2$scrollsToErrorA === void 0 ? true : _ref2$scrollsToErrorA,
      validate = _ref2.validate,
      onChange = _ref2.onChange,
      wrapperCss = _ref2.wrapperLss,
      props = _objectWithoutProperties(_ref2, ["children", "onSubmit", "scrollsToErrorAfterSubmit", "validate", "onChange", "wrapperLss"]);

  return React.createElement(Formik, Object.assign({}, props, {
    validate: squashValidate(validate),
    onSubmit: handleSubmit(onSubmit)
  }), function (formProps) {
    return React.createElement(FormWrapper, {
      lss: wrapperCss,
      noValidate: true,
      onSubmit: formProps.handleSubmit,
      onReset: formProps.handleReset
    }, onChange ? React.createElement(FormOnChangeTracker, {
      form: formProps,
      onChange: onChange
    }) : null, scrollsToErrorAfterSubmit ? React.createElement(FormErrorScroller, Object.assign({}, formProps)) : null, children);
  });
}